//#region  import
import HOOK from "../components/hooks"
import { JARGON } from '../data/Jargon'
import { COUNTRY } from "../modules/Countries"
import { COLOR, FILTERS } from "../modules/colors_&_filters"
import TOOLTIP from "../modules/tooltips"
//#endregion import

export { COLOR, COUNTRY, FILTERS, JARGON, TOOLTIP }

let index

export const CONSTANTS = {
  DEMO_USER: "demo@martincoulthard.com",
  GET_LEVEL_2: true,
  ENABLE_DRAG: true,
  ENABLE_INITIAL_POSITIONS: true,
  MAINTAIN_POSITIONS: false,
  ENABLE_LINK_TIP: true,
  ENTER_PASSWORD_TWICE: false,
  ENABLE_LOGOS: true,
  TRIAL_INVALID: -9999,
  STANDARD_TRIAL_LENGTH: 14, // days
  SHOW_ORIGINAL_NEWS_HTML: false,
  THE350CLUB_ENABLED: false, // false: any URL with ?source=350club shows The350ClubClosed page instead of the app
}

export const URL_SOURCE = {
  NUMERABLE: "numerable",
  CLUB350: "350club",
}

index = 0
export const ACTIVITY_STATUS = {
  ACTIVE: index++,
  IDLE: index,
}

export const IN_YEAR = {
  DAYS: 365.24219,
  MILLISECS_IN_YEAR: 365.24219 * 24 * 60 * 60 * 1000
}

export const COMPANY_STATUS = {
  ACTIVE: "active",
  DISSOLVED: "dissolved",
}

export const COMPANY_REG_TYPE = {
  LTD: "Limited",
  PLC: "PLC",
  OTHER: "Other",
}

export const COMMITTEE = {
  AUDIT: "Audit",
  REMCOM: "Remuneration",
  NOMCOM: "Nomination",
  NONEXISTANT: {
    COLOR: COLOR.VERY_LIGHT_GREY,
  },
  CHAIR: 1,
  MEMBER: 2,
}

export const CMTES = {
  AUD: "aud",
  REM: "rem",
  NOM: "nom",
}

const NUMERABLE_IO = "numerable.io"

export const LINKS = {
  NUMERABLE: {
    APP: `HTTPS://app.${NUMERABLE_IO}`,
    BASE: `HTTPS://www.${NUMERABLE_IO}`,
    INFO: `info@${NUMERABLE_IO}`,
  },
  COMPANIES_HOUSE: "https://find-and-update.company-information.service.gov.uk",
  GOOGLE: {
    MAPS: "https://www.google.com/maps/embed/v1/place?key=AIzaSyABH1YOk4ZQvYpJVfJdqAdiEa3qJOwLaVg&zoom=11&q=",
    VIEWER: "https://docs.google.com/viewer?url=",
  },
}

index = 0
// Check all references if changes/additions are made
export const BASE = {
  DASHBOARD: index++,
  LSE350: index++,
  LSE: {
    COMPANIES: index++,
    ROLES: index++,
    PEOPLE: index++,
    NEWS: index++,
    ADVISERS: index++,
  },
  ADVISER: index++,
  COMPANY: index++,
  PERSON: index++,
  NEWS_RELEASE: index++,
  SEARCH: index++,
  FAVOURITES: index++,
  STATUS: index++,
}

export const COOKIES = {
  URL_TRIAL_COOKIE: "url-trial-modal",
  NO_350_CLUB_MODAL_COOKIE: "dont-show-350club-intro-modal",
}

export const MONTHS = {
  SHORT: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  FULL: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
}

export const DATES = {
  UNKNOWN_FROM_YEAR: 1989,
  UNKNOWN_FROM_MONTH: 0,
  TIME_START_YEAR: 1970,
  TIME_START_MONTH: 0,
  FUTURE: new Date(JARGON.FUTURE_DATE),
  FUTURE_YEAR: new Date(JARGON.FUTURE_DATE).getFullYear(),
}

export const KEY_VALUES = {
  NAVBAR_HEIGHT: 50,
  TABBAR_HEIGHT: 60,
  TITLEBAR_HEIGHT: 64,
  TAB_MIN_WIDTH: 0, // 70,
  TABLE_ROW_HEIGHT: 50,
  FOOTER_HEIGHT: 40,
  DISABLED_OPACITY: "35%",
  MAX_FAVOURITES: 500,
  DEFAULT_ROWS_PER_PAGE: 25,
  MIN_CHECKBOXES_FOR_SELECT_ALL: 5,
  MAX_CSV_ROWS: 500,
  MAX_APPTS: 500, // max number of appointments permitted for a single api call
  MIN_SEARCH_STR_LEN: 4, // The minimum no. of chars. required for the search string
  TOOLTIP_DELAY: 1000,
}

const HOUR = 60 * 60 * 1000
export const MILLISECS = {
  APPTS_META: HOUR * 2,
  COMPANIES_META: HOUR * 2,
  NEWS_META: HOUR * 0.2,
  PEOPLE_META: HOUR * 2,
}

export const LAYOUT = {
  COMMITTEE: {
    WIDTH: "auto", // The width of the chair and menber columns
    ALIGNMENT: "center",
  },
  STAR_WIDTH: 50,
  LOGO_WIDTH: 100,
  SEARCH_LANDSCAPE_MENU_WIDTH: 420,

  LANDSCAPE_MENU_WIDTH: 260,
  CHECKBOX_LEFT_PADDING: 12,
  MENU_FIRST_PADDING: 3, // paddingLeft for 1st button on menu

  COLUMN_PADDING: 20,
  ICON_SHIFT: 4,
  SCROLL_BAR_WIDTH: 15,
  CARD_BORDER_THICKNESS: 1,
  HOME: { // Home page (search, lse companies etc )
    PADDING: {
      BORDER: 20, // For use when left follows right aligned column  ( eg right|  right|left  |right )
      LEFT: 0,
      RIGHT: 5,
    },
  },
  TICK: "\u2713", // ✓ Check mark used in various places
}

export const CARD = {
  BACKGROUND_COLOR: "white",
  MARGIN: 10,
  PADDING_VERT: 6, // 8,
  // SHADOW: "0px 5px 15px 0px #C0C0C0",
  FONT_SIZE: 14,
  BORDER: `${LAYOUT.CARD_BORDER_THICKNESS}px solid ${COLOR.MID_GREY}`,
  RADIUS: 5,
  TITLE: {
    FONT_SIZE: 16,
    FONT_WEIGHT: "bold",
    BACKGROUND_COLOR: COLOR.BRAND.LIGHT,
  },
  CONTAINER: {
    BACKGROUND_COLOR: COLOR.VERY_LIGHT_GREY,
    WIDTH: "100%",
  },
  ENVELOPE: {
    DISPLAY: "flex",
    FLEXWRAP: "wrap",
    MARGIN: "auto",
    MAXWIDTH: 1050,
    PADDING: "20px",
  },
}

export const BLOCK = {
  MARGIN: 15,
  PADDING_VERT: 6, // 8,
  // SHADOW: "0px 5px 15px 0px #C0C0C0",
  COLOR: "white",
  FONT_SIZE: 14,
}

export const MENU = {
  INFO: 1,
  ADDRESS: 2,
  ACCOUNTS: 3,
  CONNECTIONS: 4,
  WEBSITE: 5,
  LINKEDIN: 6,
}

export const VIEW = {
  D3: 0,
  TABLE: 1,
  TIMELINE: 2,
}

export const RADIO = { // Titlebar radio button settings
  [BASE.LSE.COMPANIES]: {
    OVERVIEW: 0,
    BOARD: 1,
    GOVERNANCE: 2,
    DATES: 3,
    COMMITTEES: 4,
    ADVISERS: 5,
  },
  [BASE.COMPANY]: {
    DASHBOARD: 0,
    BOARD: 1,
    COMMITTEES: 2,
    NEWS: 3,
    ADVISER_CLIENTS: 4,
    CONNECTIONS: 5,
  },
  [BASE.PERSON]: {
    ROLES: 0,
    COMMITTEES: 1,
    NEWS: 2,
    CONNECTIONS: 3,
  },
  [BASE.LSE.ROLES]: {
    BOARD: 0,
    COMMITTEES: 1,
  },
  [BASE.LSE.PEOPLE]: {
    BOARD: 0,
    COMMITTEES: 1,
  },
  [BASE.LSE.NEWS]: {
    MONTH: 0,
    YEAR: 1,
  },
  [BASE.FAVOURITES]: {
    COMPANIES: 0,
    PEOPLE: 1,
  },
}

// Set radio defaults
RADIO[BASE.LSE.COMPANIES].DEFAULT = RADIO[BASE.LSE.COMPANIES].OVERVIEW
RADIO[BASE.LSE.ROLES].DEFAULT = RADIO[BASE.LSE.ROLES].BOARD
RADIO[BASE.COMPANY].DEFAULT = RADIO[BASE.COMPANY].BOARD
RADIO[BASE.PERSON].DEFAULT = RADIO[BASE.PERSON].ROLES
RADIO[BASE.LSE.PEOPLE].DEFAULT = RADIO[BASE.LSE.PEOPLE].BOARD
RADIO[BASE.LSE.NEWS].DEFAULT = RADIO[BASE.LSE.NEWS].MONTH
RADIO[BASE.FAVOURITES].DEFAULT = RADIO[BASE.FAVOURITES].COMPANIES

export const SCROLLBAR = {
  AH_TIMEOUT: 2000,
  AH_DURATION: 500,
}

export const TENSE_ENUM = {
  CURRENT: 0,
  NOTICE: 1,
  PAST: 2,
  FUTURE: 3,
}

export const TENSE_BIT_ENUM = {
  CURRENT: 1,
  NOTICE: 2,
  PAST: 4,
  FUTURE: 8,
}

export const LSE_INDEX_ENUM = {
  FTSE_100: 0,
  FTSE_250: 1,
  FTSE_SmallCap: 2,
  AIM_All_Share: 3,
  Other_LSE: 4,
}

export const TENSE = {
  [TENSE_ENUM.CURRENT]: {
    NAME: "Current",
    COLOR: COLOR.GOOD, // green
  },
  [TENSE_ENUM.NOTICE]: {
    NAME: "Current (Outgoing)",
    COLOR: COLOR.WARN, // "#FF8000", // orange
  },
  [TENSE_ENUM.PAST]: {
    NAME: "Past",
    COLOR: COLOR.BAD, // "#FF0000", // red
  },
  [TENSE_ENUM.FUTURE]: {
    NAME: "Incoming",
    COLOR: COLOR.FUTURE
  },
}

export const CATEGORY = {
  PERSON: "person",
  COMPANY: "company",
  NEWS: "news",
}

export const LSE_DASHBOARD_CARD = {
  NEWS: 0,
  APPOINTMENTS: 1,
  LISTING_CHANGES: 2,
  RESIGNATIONS: 3,
  ANNUAL_REPORTS: 4,
}

export const COMPANY_DASHBOARD_CARD = {
  CORE: 0,
  BOARD: 1,
  GOVERNANCE: 2,
  DATES: 3,
  ADVISERS: 4,
}

export const PATH = {
  [BASE.ADVISER]: "adviser",
  [BASE.COMPANY]: "company",
  [BASE.DASHBOARD]: "dashboard",
  [BASE.FAVOURITES]: "favourites",
  [BASE.LSE.ADVISERS]: "lse-advisers",
  [BASE.LSE.COMPANIES]: "lse-companies",
  [BASE.LSE.ROLES]: "lse-appointments",
  [BASE.LSE.NEWS]: "lse-news",
  [BASE.LSE.PEOPLE]: "lse-people",
  [BASE.LSE350]: "lse",
  [BASE.NEWS_RELEASE]: "news-release",
  [BASE.PERSON]: "person",
  [BASE.SEARCH]: "search",
  [BASE.STATUS]: "status",

  ABOUT: "about",
  AI_COSTS: "ai-costs",
  BOOKMARKING: "bookmarking",
  CONFIRM: "confirm",
  CSEARCH: "csearch",
  DELETE_ACCOUNT: "delete-account",
  EDIT_LOGO: "edit-logo",
  FORGOT_PASSWORD: "forgot-password",
  GOODBYE: "goodbye",
  LOGIN: "login",
  LSE_BOARD: "lse-board",
  MONITORING_CONFIG: "monitoring-config",
  MY_ACCOUNT: "my-account",
  USER_ALERTS_CONFIG: "user-alerts-config",
  PRIVACY: "privacy",
  PSEARCH: "psearch",
  REGISTER: "register",
  SET_NEW_PASSWORD: "set-new-password",
  T_AND_C: "t-and-c",
}

// NB: The INDEX values in the below object must be kept in sync with the order in which the tabs are added to the tabOptions array in HomePageTabs.jsx
index = 0
export const TAB = {
  [BASE.SEARCH]: {
    INDEX: index++,
    PATH: PATH[BASE.SEARCH],
  },
  [BASE.DASHBOARD]: {
    INDEX: index++,
    PATH: PATH[BASE.DASHBOARD],
  },
  [BASE.LSE.COMPANIES]: {
    INDEX: index++,
    PATH: PATH[BASE.LSE.COMPANIES],
  },
  [BASE.LSE.ROLES]: {
    INDEX: index++,
    PATH: PATH[BASE.LSE.ROLES],
  },
  [BASE.LSE.PEOPLE]: {
    INDEX: index++,
    PATH: PATH[BASE.LSE.PEOPLE],
  },
  [BASE.LSE.NEWS]: {
    INDEX: index++,
    PATH: PATH[BASE.LSE.NEWS],
  },
  [BASE.LSE.ADVISERS]: {
    INDEX: index++,
    PATH: PATH[BASE.LSE.ADVISERS],
  },
  [BASE.COMPANY]: {
    INDEX: index++,
    PATH: PATH[BASE.COMPANY],
  },
  [BASE.PERSON]: {
    INDEX: index++,
    PATH: PATH[BASE.PERSON],
  },
  [BASE.NEWS_RELEASE]: {
    INDEX: index++,
    PATH: PATH[BASE.NEWS_RELEASE],
  },
  [BASE.FAVOURITES]: {
    INDEX: index++,
    PATH: PATH[BASE.FAVOURITES],
  },

  // NB: There is no RANDOM tab. This is only used for
  // read/write currentUrl[TAB.RANDOM.INDEX]currentUrl
  RANDOM: {
    INDEX: index++,
    PATH: PATH[BASE.SEARCH],
  },

  COUNT: index, // tab count

  //#region functions
  lseCompany: tabIndex =>
    tabIndex === TAB[BASE.LSE.COMPANIES].INDEX
    || tabIndex === TAB[BASE.LSE.ROLES].INDEX
    || tabIndex === TAB[BASE.LSE.PEOPLE].INDEX
    || tabIndex === TAB[BASE.LSE.NEWS].INDEX
    || tabIndex === TAB[BASE.DASHBOARD].INDEX
    || tabIndex === TAB[BASE.NEWS_RELEASE].INDEX
    || tabIndex === TAB[BASE.LSE.ADVISERS].INDEX,

  isRestrictedLse: tabIndex =>
    tabIndex === TAB[BASE.LSE.COMPANIES].INDEX
    || tabIndex === TAB[BASE.LSE.ROLES].INDEX
    || tabIndex === TAB[BASE.LSE.PEOPLE].INDEX
    || tabIndex === TAB[BASE.LSE.NEWS].INDEX
    || tabIndex === TAB[BASE.NEWS_RELEASE].INDEX
  //#endregion
}

index = 0
export const STATUS = {
  NEXUS: {
    CLEAR: "clear",
    RECEIVING: "receiving"
  },
  GOOD: index++,
  INFO: index++,
  WARN: index++,
  BAD: index++,
}

export const MAX = {
  SECOND_LEVEL: 25, // the max number of 1st level entities for which we get 2nd level
}

export const SCOPE = {
  COMPANIES: "companies",
  OFFICERS: "officers",
  RANDOM: "random companies",
}

// POSITION_ENUM must reflect corresponding backend PositionTypeBitEnum
export const POSITION_ENUM = {
  CEO: 1,
  CFO: 2,
  OTHER_EXEC_DIRECTOR: 4,
  CHAIRMAN: 8,
  SENIOR_NON_EXEC: 16, // Senior Independent Non-Exec
  NON_EXEC_DIRECTOR: 32,
  OTHER: 64,
  SECRETARY: 128,
  PSC: 256,
}

// POSITION_TYPE must reflect corresponding backend PositionTypeEnum
index = 0
export const POSITION_TYPE = {
  CEO: index++,
  CFO: index++,
  OTHER_EXEC_DIRECTOR: index++,
  CHAIRMAN: index++,
  SENIOR_NON_EXEC: index++, // Senior Independent Non-Exec
  NON_EXEC_DIRECTOR: index++,
  OTHER: index++,
  SECRETARY: index++,
  PSC: index++,
}

export const POSITION = {
  [POSITION_ENUM.CEO]: {
    NAME: "CEO",
    COLOR: "black",
    FONT_WEIGHT: "normal", // "bold",
  },
  [POSITION_ENUM.CFO]: {
    NAME: "CFO",
    COLOR: "black", // "#0554ff", // adjusted blue,
    FONT_WEIGHT: "normal", // "bold",
  },
  [POSITION_ENUM.OTHER_EXEC_DIRECTOR]: {
    NAME: "Other Exec. Director",
    COLOR: "black", // "#c57000", // triadic brown 900
    FONT_WEIGHT: "normal",
  },
  [POSITION_ENUM.CHAIRMAN]: {
    NAME: "Chair",
    COLOR: "black", // "#00a37a", // complementary turquoise 600
    FONT_WEIGHT: "normal", // "bold",
  },
  [POSITION_ENUM.SENIOR_NON_EXEC]: {
    NAME: "Senior Indep. Director",
    COLOR: "black", // "mediumvioletred",
    FONT_WEIGHT: "normal", // "bold",
  },
  [POSITION_ENUM.NON_EXEC_DIRECTOR]: {
    NAME: "Non-Exec. Director",
    COLOR: "black",
    FONT_WEIGHT: "normal",
  },
  [POSITION_ENUM.OTHER]: {
    NAME: "Director",
    COLOR: "black", // COLOR.DARK_GREY,
    FONT_WEIGHT: "normal",
  },
  [POSITION_ENUM.SECRETARY]: {
    NAME: "Company Secretary",
    COLOR: COLOR.DARK_GREY, // "black", // COLOR.BRAND.NUMERABLE,
    FONT_WEIGHT: "normal",
  },
  [POSITION_ENUM.PSC]: {
    NAME: "PSC",
    COLOR: COLOR.DARK_GREY, // "black", // COLOR.BRAND.NUMERABLE,
    FONT_WEIGHT: "normal",
  },
}

export const EXEC_ENUM = {
  EXEC: 0,
  NON_EXEC: 1,
  UNKNOWN: 2,
}

export const EXEC = {
  [EXEC_ENUM.EXEC]: {
    NAME: "Exec",
    COLOR: "#249296", // "#1d86bf", // "#1384bd", // "#77bbea",
    FONT_WEIGHT: "normal",
    SHORT: "Exec",
  },
  [EXEC_ENUM.NON_EXEC]: {
    NAME: "Non-Exec",
    COLOR: "#b84e96", // "#b53477", // "#ff80ca", // "#ff94cf",
    FONT_WEIGHT: "normal",
    SHORT: "NonEexec",
  },
  [EXEC_ENUM.UNKNOWN]: {
    NAME: "Unknown",
    COLOR: COLOR.UNKNOWN,
    FONT_WEIGHT: "normal",
    SHORT: JARGON.UNKNOWN,
  },
}

export const INDP_ENUM = { // Independent
  INDP: 0,
  NON_INDP: 1,
  UNKNOWN: 2,
}

export const INDP = {
  [INDP_ENUM.INDP]: {
    NAME: "Independent",
    COLOR: "#249296", // "#1d86bf", // "#1384bd", // "#77bbea",
    FONT_WEIGHT: "normal",
    SHORT: "Indp",
  },
  [INDP_ENUM.NON_INDP]: {
    NAME: "Non-Independent",
    COLOR: "#b84e96", // "#b53477", // "#ff80ca", // "#ff94cf",
    FONT_WEIGHT: "normal",
    SHORT: "Non-Indp",
  },
  [INDP_ENUM.UNKNOWN]: {
    NAME: "Unknown",
    COLOR: COLOR.UNKNOWN,
    FONT_WEIGHT: "normal",
    SHORT: JARGON.UNKNOWN,
  },
}

export const SEX_ENUM = {
  MALE: 0,
  FEMALE: 1,
  UNKNOWN: 2,
}

export const SEX = {
  [SEX_ENUM.MALE]: {
    NAME: "Male",
    COLOR: "#249296", // "#1d86bf", // "#1384bd", // "#77bbea",
    FONT_WEIGHT: "normal",
    SHORT: "M",
  },
  [SEX_ENUM.FEMALE]: {
    NAME: "Female",
    COLOR: "#b84e96", // "#b53477", // "#ff80ca", // "#ff94cf",
    FONT_WEIGHT: "normal",
    SHORT: "F",
  },
  [SEX_ENUM.UNKNOWN]: {
    NAME: "Unknown",
    COLOR: COLOR.UNKNOWN,
    FONT_WEIGHT: "normal",
    SHORT: JARGON.UNKNOWN,
  },
}

index = 0
export const TYPE = {
  DATE: index++,
  DOB: index++,
  FLOAT: index++,
  STRING: index++,
  NUMBER: index++,
  INTEGER: index++,
}

export const ROLE_STATUS = {
  CURRENT: null, // "role is still continuing",
  FUTURE: "role has not started yet",
}

index = 0
export const KIND = {
  FAVOURITE: {
    COMPANIES: "favourite#companies",
    PEOPLE: "favourite#people",
  },
  SEARCH: {
    ADVANCED: "search#advanced-search",
    COMPANIES: "search#companies",
    OFFICERS: "search#officers",
    DISQUALIFIED: "search#disqualified-officers",
    RESULTS: {
      COMPANY: "searchresults#company",
      OFFICER: "searchresults#officer",
      ADVANCED: "search-results#company", // Advanced company search
    }
  },
  DASHBOARD: index++,
  LSE: {
    PEOPLE: {
      BOARD: index++,
      COMMITTEES: index++,
    },
    NEWS: index++,
    COMPANIES: {
      OVERVIEW: index++,
      BOARD: index++,
      COMMITTEES: index++,
      GOVERNANCE: index++,
      DATES: index++,
      ADVISERS: index++,
    },
    ROLES: {
      BOARD: index++,
      COMMITTEES: index++,
    },
    ADVISERS: index++,
  },
  NEXUS: {
    COMPANY: {
      DASHBOARD: index++,
      BOARD: index++,
      COMMITTEES: index++,
      NEWS: index++,
      ADVISER_CLIENTS: index++,
      CONNECTIONS: index++,
    },
    PERSON: {
      ROLES: index++,
      COMMITTEES: index++,
      NEWS: index++,
      CONNECTIONS: index++,
    },
  },
  NEWS_RELEASE: index++,

  // The some() method tests whether at least one element in the array passes the test
  // Usage eg KIND.someEqual(KIND.FAVOURITE, "favourite#people") returns true
  someEqual: (object, kind) => Object.keys(object).some(key => object[key] === kind),
}

export const FORMATTING = {
  asc: "asc",
  desc: "desc",
  birthYear: "birthYear",
  black: "black",
  bold: "bold",
  border1: `1px solid ${COLOR.LIGHT_GREY}`,
  center: "center",
  country: "country",
  date: "date",
  dob: "dob",
  dobMonYear: "dobMonYear",
  float: "float",
  integer: "integer",
  left: "left",
  local: "local",
  none: "none",
  normal: "normal",
  number: "number",
  percent: "percent",
  poundsM: "poundsM", // millions pounds
  right: "right",
  string: "string",
  top: "top",
  title: "titleCase",
  yearsMonths: "yearsMonths",
}

export const TIMELINE = {
  GRID_SPACE: 5, // number of years between grid lines
  START_YEAR: 2000, // must be a multiple of grid space
  END_YEAR: 2030, // must be a multiple of grid space
  LEGEND_MARGIN: 5,
  FONT_SIZE: 14,
  ROW_HEIGHT: 40,
  VERTICAL_GAP: 8,
  TOOLTIP_DELAY: 1000,
  BAR_OPACITY: 0.7,
  LSE_BAR_OPACITY: 1.0,
  FUTURE_START_OPACITY: 0.7,
  FUTURE_END_OPACITY: 0,
  HANDLER_OPACITY: 0.05,
  MAJOR_GRID_LINE_SPACING: 5,
  ENABLE_CURSOR_SELECTION: true,
  ENABLE_TOOLTIP: true,
}

export const COMPLIANCE = {
  TARGETS: 5,
  PCNT: {
    FEMALE: 40.0,
    NON_EXECS: 50.0,
  },
}

index = 1 // Start at 1 to avoid !COUNT type issues
export const COLUMN = {
  AGE: index++,
  AGE_AVG: index++,
  AGE_SD: index++,
  APPOINTMENTS: index++,
  COMPANY: index++,
  COMPANY_TYPE: index++,
  COMPENSATION: index++,
  COUNTRY_OF_INCORPORATION: index++,
  DESCRIPTION: index++,
  DOB: index++,
  EMPLOYEES: index++,
  END: index++,
  EPIC: index++,
  EPICS: index++,
  FROM: index++,
  ICON: index++,
  [HOOK.INDUSTRY]: index++,
  LOCATION: index++,
  LOGO: index++,
  LSE_INDEX: index++,
  MARKET_CAP: index++,
  NAME: index++,
  NATIONALITY: index++,
  NUMBER: index++,
  OFFICER: index++,
  ORDER: index++,
  OVERLAP: index++,
  RESIDENCE: index++,
  REVENUE: index++,
  ROLE: index++,
  SEX: index++,
  STAR: index++,
  START: index++,
  STATUS: index++,
  TENURE: index++,
  UNTIL: index++,
  VIA_NAME: index++,
  VIA_PERSON: index++,
  VIA_COMPANY: index++,

  CODIRECTOR: index++,
  CONNECTED_CO: index++,

  CEO: index++,
  CFO: index++,
  DIRECTORS: index++,
  EXECS: index++,
  FEMALE: index++,
  SENIOR_FEMALE: index++,
  INDEP_NON_EXEC: index++,
  INDEP_NON_EXEC_9: index++,
  NON_EXEC_CHAIR: index++,
  NON_INDEP_NON_EXEC: index++,
  OTHER_DIRS: index++,
  PCNT_FEMALE: index++,
  PCNT_INDEP_NON_EXECS: index++,
  SECRETARY: index++,
  SID: index++,
  LEGEND: index++,
  COMPLIANT: index++,
  END_OF_FY_OF_LAST_PUBLISHED_AR: index++,
  CREATED: index++,
  CEASED: index++,
  PUB_DATE_OF_LAST_PUBLISHED_AR: index++,
  FILED: index++,
  DAYS_BEFORE_PUBLICATION: index++,
  DUE_DATE: index++,
  LAST_AGM: index++,
  NON_BRIT: index++,
  PARKER: index++,
  EM_DIRs: index++, // Number of Ethnic minority directors
  PREVIOUS_NAMES: index++,
  ACTIVITIES: index++,
  ADDRESS: index++,
  HEADLINE: index++,
  AI_SUMMARY: index++,
  PUBLICATION_DATE: index++,
  CATEGORY: index++,
  TYPE: index++,

  //#region Advisers
  AUDITOR: index++,
  ADVISER: index++,
  ADVISER_CLIENT: index++,
  AS_AUDITOR: index++,
  RECRUITING_ADVISER: index++,
  AS_RECRUITING_ADVISER: index++,
  REMUNERATION_ADVISER: index++,
  AS_REMUNERATION_ADVISER: index++,
  EXTERNAL_REVIEW: index++,
  AS_EXTERNAL_REVIEWER: index++,
  LAST: index++,
  NEXT: index++,
  TOTAL_CLIENTS: index++,
  //#endregion Advisers

  COMMITTEE_ROLES: index++,
  COMMITTEE: {
    AUDIT: {
      CHAIRS: index++,
      MEMBER: index++,
      MEMBERS: index++,
    },
    REMUNERATION: {
      CHAIRS: index++,
      MEMBER: index++,
      MEMBERS: index++,
    },
    NOMINATION: {
      CHAIRS: index++,
      MEMBER: index++,
      MEMBERS: index++,
    },
  },
  SKIP_ME: index++,
}

export const NSM_TYPE_CODES = {
  //#region Numerable only
  "ACS": "Annual Financial Report (files are on Portal)",
  "AGM": "AGM Statement",
  "COS": "Company Secretary Change",
  "CRO": "Change of Registered Office",
  "EXC": "Exchange Suspension/Restoration",
  "IR": "Half-year/Interim Report",
  "NAR": "New Accounting Reference Date",
  "NOA": "Notice of AGM (usually a Portal file)",
  "NOR": "Notice of Results",
  "RAG": "Result of AGM (often a Portal file)",
  "RSP": "Response to Statement/Event",
  "SEN": "London Stock Exchange Notice",
  //#endregion

  //#region Common (only relevant over api)
  "APP": "Change of Adviser",
  "ARI": "Announcement re: Rights Issue",
  "BOA": "Directorate Change",
  "CAN": "Change of Name",
  "DIS": "Disposal",
  "FR": "Final Results",
  "ITF": "Intention to Float",
  "LIS": "Initial admission to the Official List",
  "OFB": "Offer by",
  "OFF": "Offer for",
  "ORE": "Offer Rejection",
  "OTT": "Offer Talks Terminated",
  "OUP": "Offer Update",
  "POT": "Statement by Takeover Panel",
  "QRF": "1st Quarter Results",
  "QRT": "3rd Quarter Results",
  "REN": "Restoration of Listing",
  "SUS": "Temporary Suspension",
  "TST": "Trading Statement",
  //#endregion
}

//#region News Alerts
export const NEWS_CATEGORY = {
  1: "Directorate Changes",
  2: "Report News",
  4: "AGM News",
  8: "Other News",
  getName: () => Object.keys({ NEWS_CATEGORY })[0]
}

export const NEWS_TIP = {
  1: "change of director or company secretary",
  2: "news about Annual or Interim Reports",
  4: "notice or results of AGM",
  8: "other news",
}

export const FTSE_INDEX = {
  1: "FTSE 100",
  2: "FTSE 250",
  4: "FTSE SmallCap",
  8: "AIM All-Share",
  16: "Other LSE",
  32: "Favourite LSE Companies",
  getName: () => Object.keys({ FTSE_INDEX })[0]
}

export const INDEX_TIP = {
  1: "FTSE 100 index",
  2: "FTSE 250 index",
  4: "FTSE SmallCap index",
  8: "AIM All-Share index",
  16: "Other LSE companies",
  32: "my Favourite LSE Companies",
}

export const COMPANY_TYPE = {
  1: `${JARGON.COMPANY_TYPE.TRADE} Company`,
  2: `${JARGON.COMPANY_TYPE.INVEST} Company`,
  getName: () => Object.keys({ COMPANY_TYPE })[0]
}

export const TYPE_TIP = {
  1: "",
  2: `in AIC (${JARGON.AIC}) investment company universe`,
}
//#endregion News Alerts

//#region Monitoring of regulatory disclosures

export const MONITORING = {
  FTSE_INDEX: {
    1: "FTSE 100",
    2: "FTSE 250",
    4: "FTSE SmallCap",
    8: "AIM All-Share",
    16: "Other",
    getName: () => Object.keys({ FTSE_INDEX })[0]
  },
  FTSE_INDEX_TIP: {
    1: "FTSE 100 index",
    2: "FTSE 250 index",
    4: "FTSE SmallCap index",
    8: "AIM All-Share index",
    16: "All companies not covered by the above groups",
  },

  DISCLOSURES: "Monitoring of regulatory disclosures",
  FTSE_INDEX_INTRO: "Receive an email alert each day, listing regulatory disclosures issued by companies in the the following groups:",
  SEARCH_TERMS_INTRO: "that contain at least one of the search terms:",

  NUM_SEARCH_TERMS: 50,

  /// Minimum gap, in ms, enforced between clicks of the Monitoring 'Test' button (must match the
  /// backend's `_testMonitoringMinInterval` in Core.Services.Nsm.Monitoring)
  TEST_COOLDOWN_MS: 1 * 30 * 1000,
}

//#endregion Monitoring of regulatory disclosures

export const KINSHIP = {
  PARENT: 0,
  CHILD: 1,
}

index = 0
export const ALERTS = {
  NEWS: "Enable email news alerts",
  CATEGORY_INTRO: "Receive an email alert for each regulatory news release in category:",
  NEWS_INTRO: "that is issued by a company in:",
  TYPE_INTRO: "and is of type:",
}

export const TABLE_BIT = {
  // NB: PORTRAIT must remain as 1 because this is assumed in commonModule initTableOrder
  PORTRAIT: 1,
  CONNECTIONS: 4,
  RESIGNED: 2,
}

export const DELIMITER = {
  TAB: "tab",
  COMMA: "comma",
}

